import { Routes } from '@angular/router';
import { Dashboard } from './feature/dashboard/dashboard';
import { Reporting } from './feature/reporting/reporting/reporting';
import { CalGuardService, RoleGuardService } from '@cvx/cal-angular';
import { PrintReport } from './feature/print-report/print-report';
import { customRoleGuard } from './core/guards/custom-role.guard';

export const routes: Routes = [
     {
        path: '',
        redirectTo: 'foundation/home',
        pathMatch: 'full'
    },
    // Foundation Data routes
    {
        path: 'foundation', component: Dashboard, children: [
            { path: 'home', loadComponent: () => import('./feature/foundation-settlement/foundation-home/foundation-home').then(m => m.FoundationHome), title: "EGTL - Foundation Settlement Admin" },
            { path: 'elevation', loadComponent: () => import('./feature/foundation-settlement/elevation-data/elevation-data').then(m => m.ElevationData), title: "	EGTL - Foundation Settlement Tool" }
        ],
        canActivate: [customRoleGuard],
        data: {
            roles: [
                'NMAFSM.Admin',
                'NMAFSM.DataEntry',
                'NMAFSM.ReportsAndData'
            ],
        },
    },
    // Management routes
    {
        path: 'management', component: Dashboard, children: [
            { path: 'elevation', loadComponent: () => import('./feature/management/elevation-data/elevation-data').then(m => m.ElevationData), title: "Foundation Settlement Tool - Admin" },
            { path: 'foundation', loadComponent: () => import('./feature/management/foundation/foundation').then(m => m.Foundation), title: "EGTL - Foundation Settlement Admin" },

            { path: 'add-foundation', loadComponent: () => import('./feature/management/foundation/add-foundation/add-foundation').then(m => m.AddFoundation) },
            { path: 'delete-foundation', loadComponent: () => import('./feature/management/foundation/delete-foundation/delete-foundation').then(m => m.DeleteFoundation) },

            { path: 'sequence/:foundationId', loadComponent: () => import('./feature/management/foundation/sequence/sequence').then(m => m.Sequence) },
            { path: 'add-sequence/:foundationId', loadComponent: () => import('./feature/management/foundation/sequence/add-sequence/add-sequence').then(m => m.AddSequence) },
            { path: 'delete-sequence/:foundationId', loadComponent: () => import('./feature/management/foundation/sequence/delete-sequence/delete-sequence').then(m => m.DeleteSequence) },

            { path: 'adjacent-center-admin/:foundationId/:seqId', loadComponent: () => import('./feature/management/foundation/sequence/adjacent-center-admin/adjacent-center-admin').then(m => m.AdjacentCenterAdmin) },
            { path: 'add-adjacent-center-admin/:foundationId/:seqId', loadComponent: () => import('./feature/management/foundation/sequence/adjacent-center-admin/add-adjacent-center/add-adjacent-center').then(m => m.AddAdjacentCenter) },

            { path: 'remarks', loadComponent: () => import('./feature/management/remarks-data/remarks-data').then(m => m.RemarksData), title: "EGTL - Foundation Settlement Admin" },
            { path: 'sequence-type', loadComponent: () => import('./feature/management/sequence-type/sequence-type').then(m => m.SequenceType), title: "Foundation Settlement Tool" },
            { path: 'special-relationships', loadComponent: () => import('./feature/management/relatioship/special-relationships').then(m => m.SpecialRelationships) },
            { path: 'add-relationship', loadComponent: () => import('./feature/management/relatioship/add-relation/add-relation').then(m => m.AddRelation) },
            { path: 'user-privileges', loadComponent: () => import('./feature/management/user-privileges/user-privileges').then(m => m.UserPrivileges) }
        ],
        canActivate: [customRoleGuard],
        data: {
            roles: [
                'NMAFSM.Admin',
            ],
        },
        title: "EGTL - Foundation Settlement Admin"

    },
    // Reporting routes
    {
        path: 'reporting', component: Reporting, children: [
            { path: '', loadComponent: () => import('./feature/reporting/report-home/report-home').then(m => m.ReportHome) },
            { path: 'elv-data-by-sequence', loadComponent: () => import('./feature/reporting/reports/elv-data-by-sequence/elv-data-by-sequence').then(m => m.ElvDataBySequence) }, // this is handled in seperate component
            { path: 'report/:type', loadComponent: () => import('./feature/reporting/reports/report/report').then(m => m.Report) },
            { path: 'flagged-reports/:type', loadComponent: () => import('./feature/reporting/flagged-reports/reports/reports').then(m => m.Reports) },

        ],
        canActivate: [customRoleGuard],
        data: {
            roles: [
                'NMAFSM.Admin',
                'NMAFSM.ReportViewer',
                'NMAFSM.ReportsAndData'
            ],
        },
        title: "Foundation Settlement Reporting"
    },
    // Print Report routes
    {
        path: 'print', component: PrintReport, children: [
            { path: '', loadComponent: () => import('./feature/reporting/report-home/report-home').then(m => m.ReportHome) },
            { path: 'report', loadComponent: () => import('./feature/print-report/report-print/report-print').then(m => m.ReportPrint) },
            { path: 'flagged-report', loadComponent: () => import('./feature/print-report/flagged-report-print/flagged-report-print').then(m => m.FlaggedReportPrint) },

        ],
        canActivate: [customRoleGuard],
        data: {
            roles: [
                'NMAFSM.Admin',
                'NMAFSM.ReportViewer',
                'NMAFSM.ReportsAndData'
            ],
        },
        title: "Foundation Settlement Reporting"
    },

    { path: 'bye-bye', loadComponent: () => import('./feature/bye-bye/bye-bye').then(m => m.ByeBye) },
    { path: 'access-denied', loadComponent: () => import('./feature/access-denied/access-denied').then(m => m.AccessDenied) },
    
    {
        path: '**',
        redirectTo: 'foundation/home'
    }
];
